import http from "../../http-common";
/* eslint-disable */
class FasilitasFotoService {
  fasilitasFotoList(page, itemPerPage, fasilitasId) {
    return http.get(
      "/fasilitas-foto/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&fasilitas_id=" +
        fasilitasId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("fasilitas_id", data.fasilitas_id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/fasilitas-foto", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("fasilitas_id", data.fasilitas_id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/fasilitas-foto/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/fasilitas-foto/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new FasilitasFotoService();
